// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"bdc0b0a8","42":"4629699d","52":"245cd568","103":"b2dc3c32","497":"45b0a009","773":"9e752697"}[chunkId] + ".chunk.js";
};